import { ChangeEvent } from 'react';

interface TimePickerProps {
  value: string; // Format: "HH:mm"
  onChange: (value: string) => void;
  disabled?: boolean;
}

export default function TimePicker({ value, onChange, disabled }: TimePickerProps) {
  const hours = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
  const minutes = ['00', '15', '30', '45']; // 15-minute increments

  const [hour, minute] = value ? value.split(':') : ['', ''];

  const handleHourChange = (e: ChangeEvent<HTMLSelectElement>) => {
    onChange(`${e.target.value}:${minute || '00'}`);
  };

  const handleMinuteChange = (e: ChangeEvent<HTMLSelectElement>) => {
    onChange(`${hour || '00'}:${e.target.value}`);
  };

  return (
    <div className="flex items-center space-x-2">
      <select
        value={hour}
        onChange={handleHourChange}
        disabled={disabled}
        className="border border-divider p-2 rounded-lg text-sm focus:outline-none disabled:text-action-disabled"
      >
        <option value="" disabled>
          Hour
        </option>
        {hours.map((h) => (
          <option key={h} value={h}>
            {h}
          </option>
        ))}
      </select>
      <span>:</span>
      <select
        value={minute}
        onChange={handleMinuteChange}
        disabled={disabled}
        className="border border-divider p-2 rounded-lg text-sm focus:outline-none disabled:text-action-disabled"
      >
        <option value="" disabled>
          Minute
        </option>
        {minutes.map((m) => (
          <option key={m} value={m}>
            {m}
          </option>
        ))}
      </select>
    </div>
  );
}